export function exit(): void {
  process.exit(1);
}
